export enum ESubscriptionStatus {
  Initiated = "initiated",
  InitiatedExpired = "initiatedExpired",
  Active = "active",
  PastDue = "pastDue",
  Expired = "expired",
  Cancelled = "cancelled",
  Paused = "paused",
}
